import Input from '@components/Input';
import { Tooltip } from '@components/Tippy';
import { APP_TYPES } from '@config';
import PropTypes from 'prop-types';
import React from 'react';
import { APP_TOOLTIPS, getTooltip } from '../../../../src/texts/tooltips';
import { standardList } from '../../../app.values';

const SquarePlates = props => {
  return (
  <React.Fragment>
  <ul className="inline-list">
      {props.designStandard === standardList['Masonry'] &&
        props.buttons.slice(0, 6).map(item => (
          <li key={item.id}>
            <Tooltip content={getTooltip(item.tooltip) || "Default Tooltip"}>
              <button className={`btn btn-light ${item.id === props.activeBtn && "ImageButton--active"}`} onClick={() => {
                props.setSquare(item.count.n, item.count.m, item.ignore);
                props.onUpdate(item);
              }}>
                <span className={item.icon}/>
              </button>
            </Tooltip>
          </li>
        )
      )}

    {props.designStandard !== standardList['Masonry'] &&
      props.buttons.map(item => (
      <Tooltip key={item.id} content={getTooltip(item.tooltip) || "Default Tooltip"}>
      <li key={item.id}>
        <button className={`btn btn-light ${item.id === props.activeBtn && "ImageButton--active"}`} onClick={() => {
          let resetCustomCoords = true;
          if (item.withInput) {
            props.setCustomSquare(props.count.n, props.count.m, props.ignore);
            if (item.id === props.activeBtn)
              resetCustomCoords = false; // do not reset if user clicks again on the same custom button
          } else {
            props.setSquare(item.count.n, item.count.m, item.ignore);
          }
          if (resetCustomCoords && props.specifyCoordinates)
            props.setCustomCoordinates(false);

          props.onUpdate(item);
        }}>
          <span className={item.icon}/>
        </button>
      </li>
      </Tooltip>
    ))}

    {/* {props.appType === APP_TYPES.GENERAL_CALCULATION && props.designStandard !== standardList['Masonry'] && (
      <Tooltip key="2DEditor" content={APP_TOOLTIPS.TOOLTIP_2D_EDITOR.Content}>
        <li key="2DEditor">
          <button 
            className={`btn btn-light ${"2DEditor" === props.activeBtn && "ImageButton--active"}`}
            onClick={ () => {
              props.on2DEditor(props.panelType, props.activeBtn);
            }}
            disabled={true} // TODO: temporary until the Matlab code will be fixed
          >
            <span className="icon_editor" />
          </button>
        </li>
      </Tooltip>
    )} */}
    </ul>

    {props.buttons.find((btn) => btn.id === props.activeBtn && btn.withInput) && (
      <div className="input-group m-2">
        <div className="input-group-prepend">
          <span className="input-group-text" id="">N x P</span>
        </div>
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_FIXINGS_EACH_ROW.Content}>
          <Input
            className=""
            id="N"
            type="number"
            placeholder="nb_x"
            minValue={1}
            maxValue={25}
            value={props.count.n}
            onUpdate={value => props.setCustomSquare({n: +value})}
            disabled={props.specifyCoordinates}
          />
        </Tooltip>

        <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_FIXINGS_EACH_COLUMN.Content}>
          <Input
            id="P"
            className=""
            type="number"
            placeholder="nb_y"
            minValue={1}
            maxValue={25}
            value = {props.count.m}
            onUpdate={value => props.setCustomSquare({m: +value})}
            disabled={props.specifyCoordinates}
          />
        </Tooltip>
      </div>
    )}
    </React.Fragment>
  );
};

SquarePlates.propTypes = {
  buttons: PropTypes.array.isRequired,
  activeBtn: PropTypes.string
};

export default SquarePlates;



// WEBPACK FOOTER //
// ./src/views/Application/SquarePlates/SquarePlates.js